import { render, staticRenderFns } from "./BusStudentAttendanceTable.vue?vue&type=template&id=24da062d&scoped=true&"
import script from "./BusStudentAttendanceTable.vue?vue&type=script&lang=js&"
export * from "./BusStudentAttendanceTable.vue?vue&type=script&lang=js&"
import style0 from "./BusStudentAttendanceTable.vue?vue&type=style&index=0&id=24da062d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da062d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
